<template>
  <div class="safety">
    <div class="title-default">维权中心</div>
    <div class="safety-item">
      <div>
        <svg class="icon iconz_toast_warn" aria-hidden="true" v-if="!$store.state.hasPwd">
          <use xlink:href="#iconz_toast_warn" />
        </svg>
        <svg class="icon icontoast_succeed" aria-hidden="true" v-if="$store.state.hasPwd">
          <use xlink:href="#icontoast_succeed" />
        </svg>
        <div class="safety-name">余额支付密码</div>
        <div class="safety-state">
          <div>{{$store.state.hasPwd?"已设置":"未设置"}}</div>
          <div v-if="$store.state.hasPwd">建议您定期更换密码，设置安全性高的密码可以使帐号更安全</div>
          <div v-else>为了您的账户安全，请尽快设置余额支付密码</div>
        </div>
      </div>

      <el-button class="default-btns" @click="openPassword()">{{$store.state.hasPwd?'修改密码':'设置密码'}}</el-button>
    </div>
    <div class="safety-item">
      <div>
        <svg class="icon icontoast_succeed" aria-hidden="true">
          <use xlink:href="#icontoast_succeed" />
        </svg>
        <div class="safety-name">更换手机号</div>
        <div class="safety-state">
          <div>已绑定</div>
          <div>已绑定手机 {{phoneNum}}</div>
        </div>
      </div>

      <el-button class="default-btns" @click="openPhone()">更换手机</el-button>
    </div>
    <div class="safety-item">
      <div>
        <svg
          class="icon iconz_toast_warn"
          aria-hidden="true"
          v-if="!$store.state.userInfo.cashOutAccountAlipay"
        >
          <use xlink:href="#iconz_toast_warn" />
        </svg>
        <svg class="icon icontoast_succeed" aria-hidden="true" v-else>
          <use xlink:href="#icontoast_succeed" />
        </svg>
        <div class="safety-name">绑定支付宝账户</div>
        <div class="safety-state">
          <div>{{!$store.state.userInfo.cashOutAccountAlipay?'未设置':"已设置"}}</div>
          <div v-if="!$store.state.userInfo.cashOutAccountAlipay">请绑定支付宝账户</div>
          <div v-else>已绑定支付宝账户 {{$store.state.userInfo.cashOutAccountAlipay}}</div>
        </div>
      </div>

      <el-button
        v-if="!$store.state.userInfo.cashOutAccountAlipay"
        class="default-btns"
        @click="isUntying('ALIPAY','untying')"
      >绑定账户</el-button>
      <el-button v-else class="default-btns" @click="isUntying('ALIPAY')">解绑账户</el-button>
    </div>
    <div class="safety-item">
      <div>
        <svg
          class="icon iconz_toast_warn"
          aria-hidden="true"
          v-if="!$store.state.userInfo.cashOutAccountWechatNickname"
        >
          <use xlink:href="#iconz_toast_warn" />
        </svg>
        <svg class="icon icontoast_succeed" aria-hidden="true" v-else>
          <use xlink:href="#icontoast_succeed" />
        </svg>
        <div class="safety-name">绑定微信账户</div>
        <div class="safety-state">
          <div>{{!$store.state.userInfo.cashOutAccountWechatNickname?'未设置':"已设置"}}</div>
          <div v-if="!$store.state.userInfo.cashOutAccountWechatNickname">请绑定微信账户</div>
          <div v-else>已绑定微信账户 {{$store.state.userInfo.cashOutAccountWechatNickname}}</div>
        </div>
      </div>

      <el-button
        v-if="!$store.state.userInfo.cashOutAccountWechatNickname"
        class="default-btns"
        @click="isUntying('WECHAT','untying')"
      >绑定账户</el-button>
      <el-button v-else class="default-btns" @click="isUntying('WECHAT')">解绑账户</el-button>
    </div>
    <div id="orderlist">
      <!-- 接触绑定 -->
      <el-dialog
        :title="unType=='untying'?'验证手机号后进行账号绑定':'验证手机号后解除账号绑定'"
        @close="yzClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="untying"
        width="30%"
        class="untying"
      >
        <div>
          <div class="untying-tips">为了您的账号安全，请验证手机号后进行{{unType=='untying'?'绑定':'解绑'}}</div>
          <div class="untying-phone">
            手机号:
            <span>{{phoneNum}}</span>
          </div>
          <el-input v-model="verificationCode" placeholder="请输入验证码" maxlength="6">
            <span v-if="getYzm" slot="suffix" class="get_yzm" @click="yzmTimeMinuse()">{{yzmTtext}}</span>
            <span v-else slot="suffix" class="repeat">{{yzmTime}}S后重发</span>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="untying = false">取 消</el-button>
          <el-button
            type="primary"
            :disabled="verificationCode==''?true:false"
            @click="yzVerificationCode()"
          >确 定</el-button>
        </span>
      </el-dialog>

      <!-- 绑定支付宝账号 -->
      <el-dialog @close="yzClose" title="绑定支付宝账号" :visible.sync="dialogVisible" width="30%" class="pass">
        <div>
          <div>支付宝账号<el-input v-model="AlipayName" placeholder="请输入支付宝账号（建议打开支付宝查看）"></el-input></div>
          <div style="margin-top:12px;">真实姓名<el-input v-model="realName" placeholder="您的真实姓名"></el-input></div>
          
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="bindAlipay()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 绑定微信账号 -->
      <el-dialog @close="yzClose" title="绑定微信账号" :visible.sync="WechatPicker" width="30%" class="pass">
        <div style="height:230px;margin-top:10px;">
          <div id="qrcode" ref="qrcode"></div>
          <div style="margin-top:10px;text-align:center;">请扫描上方二维码绑定微信账户</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="WechatPicker = false">取 消</el-button>
          <el-button type="primary" @click="WechatPicker=false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";
export default {
  mixins: [geetestValCodeMixin],
  data() {
    return {
      untying: false,
      getYzm: true,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      phoneNumber: "",
      verificationCode: "",
      dialogVisible: false,
      WechatPicker: false,
      authTimetimer: "",
      unbind: "",
      unType: "",
      AlipayName: "",
      weixImg: "",
      wuxian:"",
      realName:''
    };
  },
  components: {
    Geet
  },
  // 接收注入的数据
  inject: ["reload"],
  computed: {
    phoneNum() {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return this.$store.state.userPhone.replace(reg, "$1 **** $2");
    }
  },
  methods: {
    openPhone() {
      this.$router.push({ path: "/user/safety/phone" });
    },
    openPassword() {
      this.$router.push({ path: "/user/safety/password" });
    },
    onValCodeSent() {
      this.getYzm = false;
      this.yzmTime = 60;

      this.authTimetimer = setInterval(() => {
        this.yzmTime--;
        if (this.yzmTime <= 0) {
          this.getYzm = true;
          clearInterval(this.authTimetimer);
          this.yzmTtext = "重新发送";
        }
      }, 1000);
    },
    // 验证码倒计时
    yzmTimeMinuse() {
      let _this = this;
      this.requestValCodeV2(_this.$store.state.userPhone, "safety");
    },
    // 打开解绑验证
    isUntying(type, unType) {
      this.untying = true;
      this.unbind = type;
      this.unType = unType;
    },
    // 验证验证码是否正确
    yzVerificationCode() {
      this.$message.closeAll()
      let _this = this;
      this.$post(
        `/common/platform/verif_sms_code?mobile=${_this.$store.state.userPhone}&code=${_this.verificationCode}`
      ).then(res => {
        if (res.code == 0) {
          console.log(res);
          if (res.data) {
            this.$message({
              message: "验证成功",
              type: "success"
            });
            this.untying = false;
            console.log(this.unType);
            if (!this.unType) {
              this.closeUntying(this.unbind);
            } else {
              if (this.unbind == "ALIPAY") {
                this.dialogVisible = true;
              }
              if (this.unbind == "WECHAT") {
                this.bindWechat();
              }
            }
          } else {
            this.$message("验证码错误");
          }
        } else {
          this.$message(res.message);
        }
      });
    },
    // 解除绑定
    closeUntying(type) {
      this.$fetch(`/user/api/customer/unbind`, {
        payWay: type
      }).then(res => {
        if (res.code == 0) {
          console.log(res);
          this.$message({
            message: res.message,
            type: "success"
          });
          this.getCustomer();
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取最新用户信息
    getCustomer() {
      let _this = this;
      // 用户信息
      this.$fetch(`/user/api/customer`).then(res => {
        if (res.code == 0) {
          _this.$store.state.userName = res.data.nickname;
          _this.$store.state.userPhone = res.data.username;
          _this.$store.state.userAvatar = res.data.avatar;
          _this.$store.state.hasPwd = res.data.hasPwd;
          _this.$store.state.userInfo = res.data;
          if(!!res.data.cashOutAccountWechatNickname){
            this.WechatPicker=false;
            clearInterval(_this.wuxian)
          }
        } else {
          // this.$message(res.message);
        }
      });
    },
    // 绑定支付宝账户
    bindAlipay() {
      this.$fetch(`/user/api/customer/bind`, {
        payWayEnum: "ALIPAY",
        account: this.AlipayName,
        realName:this.realName
      }).then(res => {
        if (res.code == 0) {
          console.log(res);
          this.$message({
            message: "绑定成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.AlipayName=''
          this.realName=''
          this.getCustomer();
        } else {
          this.$message(res.message);
        }
      });
    },
    // 绑定微信账户
    bindWechat() {
      let _this = this;
      this.$fetch(`/user/api/customer/bind`, {
        payWayEnum: "WECHAT"
      }).then(res => {
        if (res.code == 0) {
          console.log(res);
          _this.weixImg = res.data;
          this.WechatPicker = true;
          $("#qrcode canvas").remove();
          $("#qrcode img").remove();
          setTimeout(() => {
              this.qrcode();
          }, 500);
          this.wuxian=setInterval(() => {
          this.getCustomer()            
          }, 1000);
        } else {
          this.$message(res.message);
        }
      });
    },
    qrcode() {
      let _this = this;
      let qrcode = new QRCode("qrcode", {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: _this.weixImg // 设置二维码内容或跳转地址
      });
    },
    // 验证关闭初始化
    yzClose() {
      this.verificationCode = "";
      this.unbind = "";
      this.unType = "";
      this.AlipayName="";
      clearInterval(this.authTimetimer);
      this.getYzm = true;
      this.yzmTime = 60;
      clearInterval(this.wuxian)
    }
  }
};
</script>

<style lang="scss">
#orderlist {
  .untying {
    .el-dialog__header {
      padding: 20px 45px 10px !important;
    }
    .el-dialog__body {
      padding: 5px 45px !important;
    }
    .el-dialog__footer {
      padding: 10px 45px 20px;
    }
    .untying-tips {
      color: #909399;
      font-size: 12px;
      height: 12px;
      line-height: 1;
    }
    .untying-phone {
      font-size: 14px;
      height: 14px;
      line-height: 1;
      color: #5e6066;
      margin-top: 32px;
      margin-bottom: 10px;
      span {
        color: #2f3133;
        margin-left: 6px;
      }
    }
    .get_yzm {
      font-size: 14px !important;
      border: none !important;
      background: transparent !important;
    }
    .repeat {
      color: #ced4db !important;
      font-size: 14px !important;
      border: none !important;
      background: transparent !important;
    }
  }
}
</style>
<style lang='scss' scoped>
.safety {
  background: transparent;
  .title-default {
    background: #ffffff;
  }
  .safety-item {
    margin-top: 15px;
    height: 100px;
    background: #ffffff;
    padding: 31px 20px 31px 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      display: flex;
      align-items: center;
    }
    .icontoast_succeed {
      width: 33px;
      height: 33px;
      color: #63cf4e;
    }
    .iconz_toast_warn {
      width: 33px;
      height: 33px;
      color: #ffad16;
    }
    .safety-name {
      width: 98px;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      color: #2f3133;
      margin-left: 16px;
    }
    .safety-state {
      margin-left: 60px;
      & > div:nth-child(1) {
        color: #2f3133;
        font-size: 14px;
        height: 14px;
        line-height: 1;
      }
      & > div:nth-child(2) {
        height: 12px;
        font-size: 12px;
        color: rgba(144, 147, 153, 1);
        line-height: 1;
        margin-top: 12px;
      }
    }
    .default-btns {
      width: 80px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-color: rgba(52, 85, 211, 1);
      border-radius: 2px;
      padding: 0;
      color: #ffffff;
      font-size: 12px;
    }
  }
  #qrcode {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &/deep/ img{
      margin: 0 auto;
    }
  }
}
</style>
